import { injectGlobal } from '@bd/bdui-styles/emotion';
import colors from './colors';

const typography = {
  SanSerif: '\'proxima-nova\', sans-serif',
  Serif: '\'adriane\', serif',
  Display: 'serif',
};

injectGlobal(`
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${typography.SanSerif};
    font-weight: 300;
    font-size: 16px;
  }

  ${
    typography.SanSerif &&
    `
      .text-sans-serif {
        font-family: ${typography.SanSerif}
      }
    `
  }

  ${
    typography.Serif &&
    `
      .text-serif {
        font-family: ${typography.Serif}
      }
    `
  }

  ${
    typography.Display &&
    `
      .text-display {
        font-family: ${typography.Display}
      }
    `
  }

  a {
    color: ${colors.color1};
    &:hover {
      text-decoration: none;
      color: ${colors.color1Lighter}
    }
  }
`);

export default typography;



// WEBPACK FOOTER //
// ./src/styles/typography.js